var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeleteTrash = function SvgDeleteTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 3.825h3.958a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625h-.625v11.992c0 .591-.483 1.075-1.075 1.075H4.617a1.078 1.078 0 0 1-1.075-1.075V5.075h-.625a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h3.958v-.933c0-.575.466-1.042 1.042-1.042h4.166c.575 0 1.042.467 1.042 1.042v.933Zm-1.25-.733h-3.75v.733h3.75v-.733Zm-7.083 13.8h10.416V5.075H4.791v11.817Zm2.683-4.184 1.641-1.641-1.641-1.642a.629.629 0 0 1 0-.883.629.629 0 0 1 .883 0L10 10.183l1.642-1.641a.629.629 0 0 1 .883 0 .629.629 0 0 1 0 .883l-1.642 1.642 1.642 1.641a.629.629 0 0 1 0 .884.618.618 0 0 1-.442.183.618.618 0 0 1-.441-.183L10 11.95l-1.642 1.642a.618.618 0 0 1-.442.183.618.618 0 0 1-.441-.183.629.629 0 0 1 0-.884Z",
    fill: "current"
  })));
};
export default SvgDeleteTrash;